import React, { createContext, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';

import * as actions from './actions';
import { initialState, menuReducer } from './reducer';

export const MenuContext = createContext({});
export const MenuProvider = ({ children }) => {
  const [state, dispatch] = useReducer(menuReducer, initialState);
  const actionsWithDispatch = Object
    .entries(actions)
    .reduce((allActions, [key, value]) => ({
      ...allActions,
      [key]: value(dispatch),
    }), {});

  return (
    <MenuContext.Provider value={{ actions: actionsWithDispatch, state }}>
      {children}
    </MenuContext.Provider>
  );
};

MenuProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const withMenuControls = WrappedComponent => ({ children, ...props }) => {
  const {
    actions: { closeMenu, openMenu, setUserName } = {},
    state,
  } = useContext(MenuContext);

  return (
    <WrappedComponent
      menu={state}
      menuActions={{
        closeMenu,
        openMenu,
        setUserName,
      }}
      {...props}
    >
      {children}
    </WrappedComponent>
  );
};

// TODO: Review how strict the shape should be in order to be consumed by other components
//  without creating warnings like in tests.
export const menuPropTypes = {
  menu: PropTypes.shape({
    isVisible: PropTypes.bool.isRequired,
    userName: PropTypes.string.isRequired,
  }),
  menuActions: PropTypes.shape({
    closeMenu: PropTypes.func.isRequired,
    openMenu: PropTypes.func.isRequired,
    setUserName: PropTypes.func.isRequired,
  }),
};
